// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".src-editor-edit_panel-variants__labelledOption {\n  display: grid;\n  grid-template-columns: 88px 1fr;\n  grid-gap: 8px;\n  align-items: center;\n}\n", "",{"version":3,"sources":["webpack://./src/editor/edit_panel/variants.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".labelledOption {\n  display: grid;\n  grid-template-columns: 88px 1fr;\n  grid-gap: 8px;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"labelledOption": "src-editor-edit_panel-variants__labelledOption"
};
export default ___CSS_LOADER_EXPORT___;
